export default {
  getDocuments(state) {
    return state.documentsList
  },
  getDocument(state) {
    return state.document
  }
}
